export const heroSlides = [
  {
    src: '/assets/hero/slides/slide-01-data-center.png',
    alt: 'Centre de données et infrastructure IT',
    caption: 'Infrastructure & centres de données',
    fit: 'cover',
    position: 'center'
  },
  {
    src: '/assets/hero/slides/slide-02-server-room.png',
    alt: 'Supervision serveurs et intelligence artificielle',
    caption: 'Supervision serveurs & IA',
    fit: 'cover',
    position: 'center'
  },
  {
    src: '/assets/hero/slides/slide-03-finance.png',
    alt: 'Solutions financières et core banking',
    caption: 'Systèmes financiers & core banking',
    fit: 'cover',
    position: 'center'
  },
  {
    src: '/assets/hero/slides/slide-04-analytics.png',
    alt: 'Analyse de données et tableaux de bord',
    caption: 'Analyse & tableaux de bord',
    fit: 'cover',
    position: 'center'
  },
  {
    src: '/assets/hero/slides/slide-05-smart-farming.png',
    alt: 'Agriculture connectée et IoT',
    caption: 'IoT agricole & smart farming',
    fit: 'cover',
    position: 'center'
  },
  {
    src: '/assets/hero/slides/slide-06-agritech.png',
    alt: 'AgriTech et serre intelligente',
    caption: 'AgriTech & transformation digitale',
    fit: 'cover',
    position: 'center'
  },
  {
    src: '/assets/hero/slides/slide-07-sustainability.png',
    alt: 'Solutions durables et innovation responsable',
    caption: 'Innovation durable & RSE',
    fit: 'cover',
    position: 'center'
  },
  {
    src: '/assets/hero/slides/slide-08-network.png',
    alt: 'Ingénieur réseau et câblage fibre optique',
    caption: 'Réseaux & infrastructure fibre',
    fit: 'cover',
    position: 'center'
  }
];
